export const text = {
  otptitle:
    "Verifieer met een eenmalig wachtwoord dat naar uw e-mail is verzonden",
  otpdescription: "Voer een OTP in om te verifiëren",
  resendtxt: "Niet ontvangen",
  retry: "Probeer opnieuw",
  retryin: "Probeer het opnieuw in",
  button: "Doorgaan",
  verifying: "Controleren",
  OTPcannotbeempty: "OTP kan niet leeg zijn",
  Enteryouremailaddress: "Vul uw e-mailadres in",
};
